export const RINKS = ["sligo", "clonmel"];

export const RINK_LABEL = {
  sligo: "Sligo on Ice",
  clonmel: "Clonmel on Ice",
};

export const RINK_BADGE = {
  sligo: "bg-sky-400 text-slate-900",
  clonmel: "bg-indigo-400 text-white",
};

export const ROLE_LABEL = {
  admin: "Admin",
  staff: "Staff",
  viewer: "Viewer",
  medic: "Medic",
};

export const ROLE_BADGE = {
  admin: "bg-amber-300 text-slate-900",
  staff: "bg-emerald-300 text-slate-900",
  viewer: "bg-slate-200 text-slate-800",
  medic: "bg-rose-300 text-slate-900",
};

export const AID_PRICE = 5;

export const TS_LABEL = { yes: "TS removed", no: "TS pending", na: "TS n/a" };

export const TS_BADGE = {
  yes: "bg-emerald-300 text-slate-900",
  no: "bg-amber-200 text-slate-900",
  na: "bg-slate-200 text-slate-800",
};

export const PAYMENT_LABEL = {
  unpaid: "Unpaid",
  confirmed: "Booking confirmed",
  awaiting: "Awaiting confirmation",
  quotation: "Quotation",
  cash: "Paid · Cash",
  card: "Paid · Card",
  transfer: "Paid · Transfer",
  invoiced: "Invoiced",
  invoiced_reminder: "Invoiced · reminder sent",
};

export const PAYMENT_BADGE = {
  unpaid: "bg-amber-200 text-slate-900",
  confirmed: "bg-violet-300 text-slate-900",
  awaiting: "bg-orange-200 text-slate-900",
  quotation: "bg-slate-300 text-slate-900",
  cash: "bg-emerald-300 text-slate-900",
  card: "bg-emerald-300 text-slate-900",
  transfer: "bg-emerald-300 text-slate-900",
  invoiced: "bg-sky-300 text-slate-900",
  invoiced_reminder: "bg-rose-300 text-slate-900",
};

export const euro = (n) => `€${Number(n || 0).toLocaleString("en-IE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
